import {FACTIONS} from "../../../constants/factions";

export const UNDEAD_QUOTES = [{
  quote: 'Смерть — это не конец. Смерть — это переход на другую сторону поля боя',
  author: 'Маний Тупец, лич-надсмотрщик Ямы Голодных тел',
  factionId: FACTIONS.UNDEAD
}, {
  quote: 'Где пал твой лучший воин, через минуту встанет мой надежный слуга',
  author: 'Тиберий Фатус, главный некромант Семи Печатей и Семи Бед',
  factionId: FACTIONS.UNDEAD
}, {
  quote: 'Твой солдат умер? Сочувствую. Мой солдат только начал карьеру',
  author: 'Юния Эксувия, лич-мать Гниющих рот',
  factionId: FACTIONS.UNDEAD
}, {
  quote: 'Вторая жизнь за наш счет',
  author: 'Ливия Тенебрис, лич-повелительница восставших мертвецов Ульгримских катакомб',
  factionId: FACTIONS.UNDEAD
}, {
  quote: 'Герои умирают молодыми. Но мне они служат вечно',
  author: 'Авл Мортеус, некромант-смотритель Склепов Торгатта',
  factionId: FACTIONS.UNDEAD
}, {
  quote: 'Мы — твоя последняя надежда',
  author: 'Вибий Трехликий, лич-координатор Склепа Соединенных смертей',
  factionId: FACTIONS.UNDEAD
}]